/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useMemo, useState, useEffect } from "react";
import { useDracoGLTF } from "../../../utils/useDracoGLTF";
import { config as springConfig, useTransition } from "@react-spring/three";
import FactsAndFiguresMarker from "../factsandfigures/FactsAndFiguresMarker";

export function HVAC({ ...props }) {
  const { nodes } = useDracoGLTF("./models/heat/HVAC.glb");
  const [hardeningState, setHardeningState] = useState([]);
  const [brazingState, setBrazingState] = useState([]);
  const [bondingState, setBondingState] = useState([]);
  const [weldingState, setWeldingState] = useState([]);

  const hardeningPositions = useMemo(() => {
    var positions = [];
    nodes["hardening"].children.forEach((c) => {
      positions.push(c.position);
    });
    return positions;
  }, [nodes]);

  const brazingPositions = useMemo(() => {
    var positions = [];
    nodes["brazing"].children.forEach((c) => {
      positions.push(c.position);
    });
    return positions;
  }, [nodes]);

  const bondingPositions = useMemo(() => {
    var positions = [];
    nodes["bonding"].children.forEach((c) => {
      positions.push(c.position);
    });
    return positions;
  }, [nodes]);

  const weldingPositions = useMemo(() => {
    var positions = [];
    nodes["welding"].children.forEach((c) => {
      positions.push(c.position);
    });
    return positions;
  }, [nodes]);

  const hardeningTransition = useTransition(hardeningState, {
    from: { scale: 0 },
    enter: { scale: 1 },
    leave: { scale: 0 },
    trail: 150,
    config: springConfig.default,
  });

  const brazingTransition = useTransition(brazingState, {
    from: { scale: 0 },
    enter: { scale: 1 },
    leave: { scale: 0 },
    trail: 150,
    config: springConfig.default,
  });

  const bondingTransition = useTransition(bondingState, {
    from: { scale: 0 },
    enter: { scale: 1 },
    leave: { scale: 0 },
    trail: 150,
    config: springConfig.default,
  });

  const weldingTransition = useTransition(weldingState, {
    from: { scale: 0 },
    enter: { scale: 1 },
    leave: { scale: 0 },
    trail: 150,
    config: springConfig.default,
  });

  const hardening = hardeningTransition((style, item, t, i) => {
    return (
      <FactsAndFiguresMarker
        style={style}
        position={item}
        id={`Hardening_${i}`}
        key={`Hardening_${i}`}
        color="#ee8a81"
        circleSegments={16}
        size={0.03}
        lineHeight={1}
      />
    );
  });

  const brazing = brazingTransition((style, item, t, i) => {
    return (
      <FactsAndFiguresMarker
        style={style}
        position={item}
        id={`Brazing_${i}`}
        key={`Brazing_${i}`}
        color="#f5d07a"
        circleSegments={16}
        size={0.03}
        lineHeight={1}
      />
    );
  });

  const bonding = bondingTransition((style, item, t, i) => {
    return (
      <FactsAndFiguresMarker
        style={style}
        position={item}
        id={`Bonding_${i}`}
        key={`Bonding_${i}`}
        color="#66cc99"
        circleSegments={16}
        size={0.03}
        lineHeight={1}
      />
    );
  });

  const welding = weldingTransition((style, item, t, i) => {
    return (
      <FactsAndFiguresMarker
        style={style}
        position={item}
        id={`Welding_${i}`}
        key={`Welding_${i}`}
        color="#3cb0cd"
        circleSegments={16}
        size={0.03}
        lineHeight={1}
      />
    );
  });

  useEffect(() => {
    setHardeningState(hardeningPositions);
    setBrazingState(brazingPositions);
    setBondingState(bondingPositions);
    setWeldingState(weldingPositions);
  }, []);

  return (
    <group {...props} dispose={null}>
      <group position={nodes.HVAC_1.position}>
        {hardening}
        {brazing}
        {bonding}
        {welding}
      </group>
    </group>
  );
}

useDracoGLTF.preload("./models/heat/HVAC.glb");
